import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=1db034c8&scoped=true"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"
import style0 from "./LinkComponent.vue?vue&type=style&index=0&id=1db034c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db034c8",
  null
  
)

export default component.exports